import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router';
import { Spin } from 'antd';
import { Role } from '@/features/auth/auth.def.ts';
import { ProtectedRoutes } from '@/router/ProtectedRoutes.tsx';

const AuditLogPage = lazy(() => import('./audit-log-page.tsx'));

export const auditLogRoutes: RouteObject = {
  path: 'audit-logs',
  element: <ProtectedRoutes allowRoles={[Role.Developer]} />,
  children: [
    {
      index: true,
      element: (
        <Suspense fallback={<Spin />}>
          <AuditLogPage />
        </Suspense>
      ),
    },
  ],
};
